import register from '../register';

register( 'specs', function() {

  /**
   * Sugar for jquery like selector engine
   * @param  {String} selector
   * @return {Array}
   */
  function $( selector ) {
    return Array.prototype.slice.call(
      document.querySelectorAll( selector )
    );
  }

  let container = $('.specs')[ 0 ];
  // Horizontal scroll container for links
  let headerContainer = $('.specs-header__container')[ 0 ];
  // Link elements (key features, tech specs, station setup)
  let links = $('.specs-header__link');

  /**
   * Event handler function to set the currently active link
   * @param {HTMLElement} elem
   */
  function setActive( elem ) {
    let targetIndex = links.indexOf( elem );
    headerContainer.dataset.activeindex = targetIndex;
    container.dataset.activeindex = targetIndex;
  }

  // Event handler for links
  links.forEach( function( elem ) {
    elem.addEventListener( 'click', function( ev ) {
      setActive( ev.currentTarget );
    });
  });

});

export default undefined;
